<template>
  <!-- 入库确认 -->
  <div class="pagesBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit"
        >保存新建</el-button
      >
    </div>
    <div class="formbox">
      <el-form
        :model="baseInForm"
        :rules="rules"
        ref="baseInForm"
        label-width="110px"
        class="glo_formBox"
      >
        <el-form-item label="装卸类型:" prop="loadTypeConfDictId">
          <el-select
            v-model="baseInForm.loadTypeConfDictId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in handling_order_type_list"
              :key="index"
              :label="item.key"
              :value="item.confDictId"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <div class="teSu">
         
          <el-button class="glo_bgcMainColor formBtns">添加</el-button>
        </div> -->
        <el-form-item label="业务部门:" prop="businessDeptId">
          <el-select v-model="baseInForm.businessDeptId" placeholder="请选择">
            <el-option
              v-for="item in DeptList"
              :key="item.deptId"
              :label="item.departmentName"
              :value="item.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="装卸单价:" prop="unitPrice">
          <el-input
            v-model="baseInForm.unitPrice"
            placeholder="请输入"
            type="number"
            clearable
            @input="clickLoadFee()"
          ></el-input>
        </el-form-item>
        <el-form-item label="计费取值:" prop="billingWeight">
          <el-input
            v-model="baseInForm.billingWeight"
            placeholder="自动获取"
            type="number"
            clearable
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="装卸费合计:" prop="loadFee">
          <div class="disFlexs jsInput">
            <el-input
              v-model="baseInForm.loadFee"
              placeholder="自动合计"
              clearable
              type="number"
              disabled
            ></el-input>
            <!-- <el-button class="jsBtns glo_bgcMainColor" @click="clickLoadFee()"
              >计算</el-button
            > -->
          </div>
        </el-form-item>
        <el-form-item label="其他费用:" prop="otherFee">
          <el-input
            v-model="baseInForm.otherFee"
            placeholder="请输入"
            type="number"
            clearable
            @input="feeTotal()"
          ></el-input>
        </el-form-item>
        <el-form-item label="费用合计:" prop="totalAmount">
          <div class="disFlexs jsInput">
            <el-input
              v-model="baseInForm.totalAmount"
              placeholder="自动计算"
              clearable
              disabled
            ></el-input>
            <!-- <el-button class="jsBtns glo_bgcMainColor" @click="feeTotal()"
              >计算</el-button
            > -->
            <el-button
              style="margin-left: 8px"
              class="jsBtns glo_bgcMainColor"
              @click="tanfen1"
              >摊分</el-button
            >
          </div>
        </el-form-item>

        <el-form-item
          class="textArea"
          style="width: 100%"
          label="备注:"
          prop="remark"
        >
          <el-input
            type="textarea"
            rows="3"
            v-model="baseInForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="glo_Table rTable">
      <div class="leftLabler">装卸员</div>
      <el-table :data="tableData2" border style="width: 100%">
        <el-table-column align="center" prop="" label="装卸员" min-width="160">
          <template slot-scope="scope">
            <div class="flexBox">
              <el-select
                v-model="tableData2[scope.$index].objectStatusConfDictId"
                placeholder="请选择"
                @change="changeObjStatus($event, scope.$index)"
              >
                <el-option
                  v-for="item in object_status_list"
                  :key="item.confDictId"
                  :label="item.val"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
              <el-select
                v-model="tableData2[scope.$index].objectName"
                placeholder="请选择"
                filterable
                clearable
                remote
                :remote-method="(val) => getCustomerList(val, scope.$index)"
                :allow-create="tableData2[scope.$index].isOther"
                @change="changeobjectNumber($event, scope.$index)"
                @focus="
                  getObjectUserDownList(
                    tableData2[scope.$index].key,
                    '',
                    scope.$index
                  )
                "
              >
                <el-option
                  v-for="item in tableData2[scope.$index].CustomerList"
                  :key="item.documentId"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="billingWeight" label="装卸重量">
          <template slot-scope="scope">
            <el-input
              v-model="tableData2[scope.$index].billingWeight"
              placeholder="请输入"
              type="number"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="amount" label="金额">
          <template slot-scope="scope">
            <el-input
              v-model="tableData2[scope.$index].amount"
              placeholder="请输入"
              type="number"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="remark" label="备注">
          <template slot-scope="scope">
            <el-input
              v-model="tableData2[scope.$index].remark"
              placeholder="请输入"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <div class="iconList">
              <el-button class="tbBtns" @click="addZxy">添加</el-button>
              <el-popconfirm
                v-if="tableData2.length > 1"
                title="确定删除该行数据吗"
                @confirm="delZxy(scope.$index)"
              >
                <el-button slot="reference" class="tbBtns">删除</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="glo_Table" style="margin-bottom: 20px">
      <div class="leftLabler">运单信息</div>
      <div style="margin-bottom: 4px">
        <el-button type="primary" class="wayBtns" @click="addYd"
          >添加运单</el-button
        >
        <el-button type="primary" class="wayBtns" @click="addFcd"
          >添加发车单</el-button
        >
        <el-button type="primary" class="wayBtns" @click="AutoTf"
          >自动摊分</el-button
        >
        <el-button type="primary" class="wayBtns" @click="delBtns"
          >移除</el-button
        >
      </div>
      <el-table
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        style="width: 100%"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in tabelHeadeTitle">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'cost' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <el-input
                placeholder="请输入"
                v-model="tableData[scope.$index].cost"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      :title="dialogTitle2"
      :visible.sync="isShowDialog2"
      :modal-append-to-body="true"
      :width="diaWidth2"
      :close-on-click-modal="true"
      @close="handleCloseDia2"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogFormref2"
          :model="dialogForm2"
          label-width="100px"
        >
          <el-form-item
            class="dialogFormItems"
            prop="dialognumber"
            :label="diaType == 'addWayBillNumber' ? '运单号: ' : '发车批次号:'"
            style="width: 100%"
          >
            <el-input
              clearable
              v-model.trim="dialogForm2.dialognumber"
              placeholder="请输入一个单号"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          class="diaBtns"
          style="margin-right: 50px"
          size="mini"
          @click="isShowDialog2 = false"
          >关 闭</el-button
        >
        <el-button
          class="diaBtns glo_bgcMainColor"
          type="primary"
          size="mini"
          @click="diaConfirmBtn2"
          >添加</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  components: { uploadimgs, myDialog },
  data() {
    return {
      baseInForm: {
        billingWeight: "",
        businessDeptId: "",
        loadFee: "",
        loadTypeConfDictId: "",
        objectUserReqs: [],
        waybillReqs: [],
        otherFee: "",
        remark: "",
        totalAmount: "",
        unitPrice: "",
      },
      tableData: [],
      tableData2: [
        {
          isOther: false,
          amount: "",
          billingWeight: "",
          objectName: "",
          objectNumber: "",
          objectStatusConfDictId: "",
          remark: "",
          CustomerList: [],
        },
      ],
      rules: {
        aaa: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
      },
      selectTableData: [],
      handling_order_type_list: [], //装卸类型
      DeptList: [], //业务网点
      object_status_list: [], //业务网点

      // 默认表头
      tabelHeadeTitle: [
        {
          name: "分摊成本",
          field: "cost",
          width: "140",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "计费取值",
          field: "totalBillingWeight",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "客户单号",
          field: "customereOrderNumber",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开单部门",
          field: "businessDeptName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "终端部门",
          field: "endDeptName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务日期",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "品名",
          field: "goodsName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "包装",
          field: "packageName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "交接方式",
          field: "sendMethod",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单送货费",
          field: "sendFee",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货人手机",
          field: "receivePhone",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货省份",
          field: "receiveProvinceName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货地址",
          field: "receiveAddress",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单要求",
          field: "rnRequireName",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "开单重量(kg)",
          field: "totalWeight",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开单体积(m³)",
          field: "totalVolume",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "开单运费",
          field: "billingAmount",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "代收货款",
          field: "agentAmount",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "到付金额",
          field: "receivedAmount",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "开单备注",
          field: "remarks",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],

      isShowDialog2: false,
      dialogTitle2: "",
      diaWidth2: "40%",
      diaType: "",
      dialogForm2: {
        // 弹窗表单数据
        dialognumber: "",
      },

      totalArr: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getConfDictValDownList("handling_order_type"); // 装卸类型
    this.getConfDictValDownList("object_status"); // 装卸类型
    this.getDeptList(); //业务部门
    let totalArr = [];
    this.tabelHeadeTitle.forEach((item) => {
      if (item.isTotal) {
        totalArr.push(item.field);
      }
    });
    this.totalArr = totalArr;
  },
  activated() {},
  destroyed() {},
  methods: {
    // 装卸费合计 = 装卸单价*计费取值
    clickLoadFee() {
      // loadFee
      let num1 = this.baseInForm.unitPrice || 0;
      let num2 = this.baseInForm.billingWeight || 0;
      this.baseInForm.loadFee = this.$TOOLS.mul(num1, num2).toFixed(2);
      this.feeTotal();
    },
    // 费用合计 = 其他费用+装卸费合计
    feeTotal() {
      // loadFee
      let num1 = this.baseInForm.loadFee || 0;
      let num2 = this.baseInForm.otherFee || 0;
      this.baseInForm.totalAmount = this.$TOOLS.add(num1, num2).toFixed(2);
      this.AutoTf();
    },
    submit() {
      let param = JSON.parse(JSON.stringify(this.baseInForm));
      let objectUserReqs = JSON.parse(JSON.stringify(this.tableData2)) || [];
      let waybillReqs = JSON.parse(JSON.stringify(this.tableData)) || [];

      for (var i = 0; i < objectUserReqs.length; i++) {
        if (!objectUserReqs[i].objectName) {
          this.$message.error("装卸员不能为空");
          return false;
        }
      }
      objectUserReqs.forEach((item) => {
        delete item.isOther;
        delete item.key;
      });

      param.objectUserReqs = objectUserReqs;

      let arrs = [];
      arrs = waybillReqs.map((item) => {
        let objs = {
          cost: item.cost || 0,
          waybillSplitId: item.waybillSplitId,
        };
        return objs;
      });
      param.waybillReqs = arrs;

      this.$API.wtl_addHandlingOrder(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.cleraPage();
      });
    },

    cleraPage() {
      this.baseInForm = {
        billingWeight: "",
        businessDeptId: "",
        loadFee: "",
        loadTypeConfDictId: "",
        objectUserReqs: [],
        waybillReqs: [],
        otherFee: "",
        remark: "",
        totalAmount: "",
        unitPrice: "",
      };
      this.tableData = [];
      this.tableData2 = [
        {
          isOther: false,
          amount: "",
          billingWeight: "",
          objectName: "",
          objectNumber: "",
          objectStatusConfDictId: "",
          remark: "",
          CustomerList: [],
        },
      ];
    },
    // 添加运单
    addYd() {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "添加运单";
      this.diaType = "addWayBillNumber";
    },
    // 添加发车单
    addFcd() {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "添加发车单";
      this.diaType = "addFCNumber";
    },
    // 自动摊分
    AutoTf() {
      let nums = this.baseInForm.totalAmount || 0;
      if (this.tableData.length == 0) {
        this.$message.error("运单信息不能为空,请先添加运单").showClose = true;
        return false;
      }
      if (nums == 0) {
        this.$message.error("费用合计不能为0").showClose = true;
        return false;
      }
      let datas = JSON.parse(JSON.stringify(this.tableData));
      datas.forEach((item) => {
        let num2 = this.$TOOLS
          .divide(item.totalBillingWeight, this.baseInForm.billingWeight)
          .toFixed(2);
        item.cost = this.$TOOLS.mul(nums, num2).toFixed(2);
      });
      this.tableData = datas;
    },
    // 移除
    delBtns() {
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择需要移除的运单").showClose = true;
        return false;
      }
      this.$confirm("是否移除选中的运单?", "提示: ")
        .then((res) => {
          let arrs = JSON.parse(JSON.stringify(this.tableData));

          for (var b = 0; b < this.selectTableData.length; b++) {
            for (var a = 0; a < arrs.length; a++) {
              if (
                arrs[a].waybillSplitId == this.selectTableData[b].waybillSplitId
              ) {
                arrs.splice(a, 1);
                a--;
              }
            }
          }
          this.tableData = arrs;
        })
        .catch((err) => {});
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
    // 选择对象类型
    changeObjStatus(e, idx) {
      console.log(e, idx);
      this.tableData2[idx].isOther = false;
      this.tableData2[idx].objectName = "";
      this.tableData2[idx].objectNumber = "";
      if (e) {
        this.object_status_list.forEach((item) => {
          if (item.confDictId == e) {
            let key = item.key;
            if (key == "other") {
              this.tableData2[idx].isOther = true;
            }

            this.tableData2[idx].key = key;
            this.getObjectUserDownList(key, "", idx);
          }
        });
      } else {
      }
    },
    changeobjectNumber(e, idx) {
      console.log("e", e);
      this.tableData2[idx].objectNumber = "";
      if (e) {
        this.tableData2[idx].CustomerList.forEach((item) => {
          if (item.name == e) {
            this.tableData2[idx].objectNumber = item.number || "";
            console.log("objectNumber", this.tableData2[idx].objectNumber);
          }
        });
      }
    },

    // 根据字典类型获取字典值下拉列表 getConfDictValDownList('handling_order_type')
    getConfDictValDownList(key) {
      this.$COMAPI.getConfDictValDownList(key).then((res) => {
        // 装卸类型
        if (key == "handling_order_type") {
          this.handling_order_type_list = res || [];
        }
        // 结算对象类型
        if (key == "object_status") {
          this.object_status_list = res || [];
        }
      }); //
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key, name, idx) {
      this.$COMAPI.getObjectUserDownList(key, name).then((res) => {
        this.tableData2[idx].CustomerList = res || [];
      });
    },
    // 远程搜索
    getCustomerList(e, idx) {
      let key = this.tableData2[idx].key;
      if (e) {
        this.getObjectUserDownList(key, e, idx);
      } else {
        this.getObjectUserDownList(key, "", idx);
      }
    },
    // 业务部门
    getDeptList() {
      this.$COMAPI.getDeptList().then((res) => {
        this.DeptList = res || [];
      });
    },
    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    // 新增装卸员
    addZxy() {
      let obj = {
        isOther: false,
        amount: "",
        billingWeight: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        remark: "",
        CustomerList: [],
      };
      this.tableData2.push(obj);
    },
    // 删除装卸员
    delZxy(idx) {
      this.tableData2.splice(idx, 1);
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      if (!this.dialogForm2.dialognumber) {
        this.$message.warning("请输入单号").showClose = true;
        return false;
      }
      if (this.diaType == "addWayBillNumber") {
        // 运单
        let param = {
          waybillNumberNoLike: this.dialogForm2.dialognumber,
        };
        this.$API.wtl_getWaybillList(param).then((res) => {
          let datas = res.data.result.data || [];
          console.log("datas", datas);
          if (datas.length == 0) {
            this.$message.warning(
              "没有查询到运单信息,请检查运单号是否正确"
            ).showClose = true;
            return false;
          }

          let arrs = JSON.parse(JSON.stringify(this.tableData));

          for (var i = 0; i < arrs.length; i++) {
            for (var j = 0; j < datas.length; j++) {
              if (arrs[i].waybillSplitId == datas[j].waybillSplitId) {
                this.$message.warning(
                  "运单: " +
                    datas[j].mainWaybillNumber +
                    "  已存在,不要重复添加"
                ).showClose = true;
                return false;
              }
            }
          }

          arrs = [...arrs, ...datas];

          let num = 0;
          arrs.forEach((item) => {
            num = this.$TOOLS.add(num, item.totalBillingWeight || 0).toFixed(2);
          });
          this.baseInForm.billingWeight = num;
          this.tableData = arrs;
          this.isShowDialog2 = false;
          this.dialogForm2.dialognumber = "";
        });
      } else {
        // 发车批次号
        let param = {
          number: this.dialogForm2.dialognumber,
        };
        this.$API.wtl_getWaybillByDispatchNumber(param).then((res) => {
          let datas = res.data.result || [];
          console.log("datas", datas);
          if (datas.length == 0) {
            this.$message.warning(
              "没有查询到运单信息,请检查批次号是否正确"
            ).showClose = true;
            return false;
          }

          let arrs = JSON.parse(JSON.stringify(this.tableData));

          for (var i = 0; i < arrs.length; i++) {
            for (var j = 0; j < datas.length; j++) {
              if (arrs[i].waybillSplitId == datas[j].waybillSplitId) {
                this.$message.warning(
                  "运单: " +
                    datas[j].mainWaybillNumber +
                    "  已存在,不要重复添加"
                ).showClose = true;
                return false;
              }
            }
          }

          arrs = [...arrs, ...datas];
          this.tableData = arrs;

          let num = 0;
          arrs.forEach((item) => {
            num = this.$TOOLS.add(num, item.totalBillingWeight || 0).toFixed(2);
          });
          this.baseInForm.billingWeight = num;

          this.isShowDialog2 = false;
          this.dialogForm2.dialognumber = "";
        });
      }
    },
    // 摊分
    tanfen1() {
      let num1 = this.baseInForm.billingWeight || 0; //计费取值
      let num2 = this.baseInForm.totalAmount || 0; //费用合计
      if (num1 == 0) {
        this.$message.error(
          "计费重量不能为空,请先添加运单信息"
        ).showClose = true;
        return false;
      }
      if (num2 == 0) {
        this.$message.error(
          "费用合计不能为空,请输入 装卸单价"
        ).showClose = true;
        return false;
      }
      let datas = JSON.parse(JSON.stringify(this.tableData2)) || [];
      let n1 = this.$TOOLS.divide(num1, datas.length).toFixed(2) || 0;
      let n2 = this.$TOOLS.divide(num2, datas.length).toFixed(2) || 0;
      datas.forEach((item) => {
        item.billingWeight = n1;
        item.amount = n2;
      });
      this.tableData2 = datas;
    },
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.formbox {
  padding: 10px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }

  // .glo_formBox {
  //   .teSu {
  //     display: flex;
  //     width: 30%;
  //     min-width: 360px;
  //   }
  // }
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}

.topBtns {
  margin: 0 30px;
  height: 50px;
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.flexBox {
  display: flex;
}

.rTable {
  // flex: 1;
  margin-bottom: 16px;
}
.leftLabler {
  width: 80px;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
}
.wayBtns {
  padding: 8px 12px;
}
</style>